
import initialStore from '../initialStore';

import type { RequestsStore } from '../../types/request';

const initialState: RequestsStore = initialStore.requests;

type Action = {
  type: string,
  [string]: any
}

function requests(state: RequestsStore = initialState, action: Action): RequestsStore {
  switch (action.type) {
  // GET actions
  case 'GET_REQUESTS_REQUEST':
    return {
      ...state,
      shouldUpdate: false,
      loading: true,
      error: null,
      didSubmit: false
    };
  case 'GET_REQUESTS_SUCCESS':
    return {
      ...state,
      loading: false,
      data: action.requests
    };

  case 'GET_REQUESTS_ERROR':
    return {
      ...state,
      loading: false,
      shouldUpdate: true,
      error: action.error
    };

  default:
    return state;
  }
}

const getNumActiveRequests = (reqs) => reqs.length;

const getNumRemaingReqs = (reqs, userLimit) =>
  (userLimit || 3) - getNumActiveRequests(reqs);

const getIsOverRequestLimit = (reqs, userLimit) =>
  getNumActiveRequests(reqs) >= (userLimit || 3);

export default requests;

export {
  getNumActiveRequests,
  getIsOverRequestLimit,
  getNumRemaingReqs
};



// WEBPACK FOOTER //
// ./src/store/reducers/requests.js